import {Dispatch} from "react"
import {messagesService} from "@dv5/api"
import {DvTaskPage} from '@dv5/domain'

interface TaskUpdateBody {
    documentId: string
    changes: DvTaskPage
}

class TaskMessagesService {
    register(dispatch: Dispatch<any>) {
        messagesService.registerService('task-page', {
            processors: {
                'content': (body: TaskUpdateBody) => {
                    // dispatch to a Redux action for task page data
                    // For now, the task page content is managed as layout content
                },
                'changed-task': (body: TaskUpdateBody) => {
                    // dispatch changes for task page
                },
            }
        })
    }
}

export const taskMessagesService = new TaskMessagesService()
